import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class OptionManagementApiService {

    constructor(private http: ApiHttpClient) { }


    public save(request: camps.OptionsSaveRequest): Observable<api.OperationResultValue<camps.OptionDefinitionDetails>> {
        return this.http.post<api.OperationResultValue<camps.OptionDefinitionDetails>>(`option`, request, true);
    }

    public remove(request: camps.OptionRemoveRequest): Observable<api.OperationResult> {
        return this.http.post<api.OperationResult>(`option/remove`, request, true);
    }
}
